// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__373vS","messages":"Chat_messages__3g0VD","dateDivider":"Chat_dateDivider__3vF8j"};